import React from 'react';
import { Box, Typography, Tooltip } from '@mui/material';
import RarityAvatar from './common/RarityAvatar';
import { avatarStyles } from '../theme/componentStyles';

const StandardText = ({ children, ...props }) => (
  <Typography variant="body2" {...props}>
    {children}
  </Typography>
);

const UpgradeRequirements = ({ requirements, currentAnimalType }) => {
  if (!requirements) return null;

  const getFoodImagePath = () => {
    const foodType = {
      'birds': 'egg',
      'cattle': 'milk',
      'fuzzies': 'fuzzies'
    }[currentAnimalType] || 'egg';
    
    return `/images/seeds/${foodType}/${requirements.food.rarity.toLowerCase()}/preview.png`;
  };

  const getFoodAltText = () => {
    return {
      'birds': 'Egg',
      'cattle': 'Milk',
      'fuzzies': 'Fuzzies'
    }[currentAnimalType] || 'Food';
  };

  return (
    <Box sx={{ 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      width: '100%',
      px: 1,
      gap: 3,
      '& > *': {
        display: 'flex',
        alignItems: 'center',
        minWidth: '100px',
        justifyContent: 'center',
        flexShrink: 0
      }
    }}>
      {requirements.animals > 0 && requirements.animalRarity && (
        <Tooltip title={requirements.animalName ? `${requirements.animalName} (${requirements.animalRarity})` : `${currentAnimalType} (${requirements.animalRarity})`} arrow>
          <Box sx={{ 
            display: 'flex', 
            alignItems: 'center',
            flexDirection: 'row',
            gap: 1,
            minWidth: '100px',
            justifyContent: 'flex-start'
          }}>
            <RarityAvatar
              src={`/images/beds/${currentAnimalType}/${requirements.animalRarity.toLowerCase()}/preview.png`}
              alt={`${requirements.animalRarity} ${currentAnimalType}`}
              size="md"
              sx={avatarStyles.standard}
            />
            <StandardText sx={{ 
              fontWeight: 600, 
              color: 'text.primary',
              whiteSpace: 'nowrap',
              textAlign: 'center',
              width: '100%'
            }}>
              × {requirements.animals}
            </StandardText>
          </Box>
        </Tooltip>
      )}

      {requirements.food && (
        <Tooltip title={`${requirements.food.rarity} Food`} arrow>
          <Box sx={{ 
            display: 'flex', 
            alignItems: 'center',
            flexDirection: 'row',
            gap: 1,
            minWidth: '100px',
            justifyContent: 'flex-start'
          }}>
            <RarityAvatar
              src={getFoodImagePath()}
              alt={`${requirements.food.rarity} ${getFoodAltText()}`}
              size="md"
              sx={avatarStyles.standard}
            />
            <StandardText sx={{ 
              fontWeight: 600, 
              color: 'text.primary',
              whiteSpace: 'nowrap',
              textAlign: 'center',
              width: '100%'
            }}>
              × {requirements.food.amount}
            </StandardText>
          </Box>
        </Tooltip>
      )}

      {requirements.cfb > 0 && (
        <Tooltip title="CFB Tokens" arrow>
          <Box sx={{ 
            display: 'flex', 
            alignItems: 'center',
            flexDirection: 'row',
            minWidth: '100px',
            justifyContent: 'flex-start'
          }}>
            <RarityAvatar
              src="/images/icon_CFB.svg"
              alt="CFB Token"
              size="md"
              sx={{
                ...avatarStyles.standard,
                border: 'none !important',
                '& img': {
                  padding: '4px',
                  objectFit: 'contain'
                }
              }}
            />
            <StandardText sx={{ 
              fontWeight: 600, 
              color: 'text.primary',
              whiteSpace: 'nowrap',
              textAlign: 'center',
              width: '100%'
            }}>
              × {requirements.cfb}
            </StandardText>
          </Box>
        </Tooltip>
      )}
    </Box>
  );
};

export default UpgradeRequirements;
